import { Delete02Icon, PencilEdit02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useNavigate } from "react-router-dom";
import { Button, ButtonBase, CardMedia, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { removeItemFromQuote, updateItemToQuote } from "@/store/quoteItemSlice";
import { openItem } from "@/store/uiSlice";
import { useAppDispatch, useAppSelector } from "@/hooks";
import ProductDetails from "../product-details/ProductDetails";
import { Content } from "@/types";
import { EmptyState } from "@/components";
const Checkout = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const items = useAppSelector((state) => state.quote.items);

  const updateItem = (item: Content) => {
    dispatch(updateItemToQuote(item));
  };

  if (!items.length) {
    return (
      <Stack spacing={2} padding={3}>
        <EmptyState
          title="Elije uno o más Productos"
          description="Cuando agregues productos se verán aquí"
          action={{ children: "agregar", onClick: () => navigate("/catalogo") }}
        />
      </Stack>
    );
  }

  return (
    <>
      <Stack spacing={2} padding={3}>
        {items?.map((product) => (
          <Stack key={product.id} direction={"row"} spacing={2}>
            <ButtonBase onClick={() => dispatch(openItem(product))}>
              <CardMedia
                className="product"
                component={"img"}
                title={product.title}
                image={product.images[0]}
                sx={{
                  width: "125px",
                  height: "125px",
                  borderRadius: "8px",
                }}
              />
            </ButtonBase>
            <Stack flex={1} height={"100%"} spacing={1}>
              <Typography variant="h2" fontSize={"18px"} sx={{ display: "flex", justifyContent: "flex-start" }}>
                {product.title}
              </Typography>
              {(Object.entries(product?.settings) ?? []).map(([settingTitle, answers]) => (
                <Stack key={settingTitle} direction={"row"} spacing={1} alignItems={"center"}>
                  <Typography variant="h3" fontSize={"14px"}>
                    {`${settingTitle}: `}
                  </Typography>
                  {answers.map((answer) => (
                    <Typography variant="body1" key={answer} fontSize={"14px"}>
                      {answer}
                    </Typography>
                  ))}
                </Stack>
              ))}
            </Stack>

            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
              <IconButton onClick={() => dispatch(openItem(product as Content))}>
                <HugeiconsIcon icon={PencilEdit02Icon} />
              </IconButton>
              <IconButton onClick={() => dispatch(removeItemFromQuote(product as Content))}>
                <HugeiconsIcon icon={Delete02Icon} style={{ color: theme.palette.primary.main }} />
              </IconButton>
            </Stack>
          </Stack>
        ))}
      </Stack>
      <Stack direction={"row"} spacing={2} padding={3}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Regresar
        </Button>
        <Button onClick={() => navigate("/contacto")} disabled={!items.length}>
          Continuar
        </Button>
      </Stack>

      <ProductDetails enableOrders={false} addItem={updateItem} />
    </>
  );
};

export default Checkout;
